import { Gamecloud } from '../../gamecloud';
import ConsoleUI from './consoleUI';

class ConsoleParent extends Gamecloud {
    protected console;
    protected ui;

    public constructor(el: JQuery, url: string) {
        super();
        this.initUi(el);
        this.loader.enable();
        this.initConsole(url);
        window.onload = () => {
            this.ui.onAutoscrollChange();
        };
    }

    protected initUi(el: JQuery): void {
        this.ui = new ConsoleUI(el);
    }

    protected initConsole(url: String): void {
        throw 'this method needs implementation in sub class'
    }
}

export default ConsoleParent;
